import { YFC } from '@/utils/constants';
import { AxiosInstance } from 'axios';
import { classToPlain } from 'class-transformer';
import { BaseService, Page, StorageManager } from 'yellowfin-ui-lib';
import { Address, Cart, CartAction, CartItem, Composition, Product, ProductsSearch } from 'yf-commerce-model-ui-lib';


export class CartService extends BaseService {

	constructor(http: AxiosInstance) {
		super(http);
	}

	getCartid(): string {
		return StorageManager.get(YFC.CART_COOKIE);
	}

	setCartId(opaqueid: string) {
		StorageManager.set(YFC.CART_COOKIE, opaqueid);
	}

	reset() {
		StorageManager.remove(YFC.CART_COOKIE);
	}

	search(search: ProductsSearch, page: Page): Promise<Product[]> {
		return this.mapResponse(this.http.post(`/ws/catalog/search/${page.start}/${page.stop}`, classToPlain(search)), Product);
	}

	loadCustomerCart(): Promise<Cart> {
		return this.mapResponse<Cart>(this.http.get(`/ws/ecommerce/cart`), Cart);;
	}

	loadCart(full?: boolean): Promise<Cart> {
		const o = this.getCartid() || '';
		const f = full && o ? '/fullreprice' : '';
		return this.mapResponse<Cart>(this.http.get(`/ws/ecommerce/cart/${o}${f}`), Cart);
	}

	add(c: Composition | undefined, p: Product, q: number): Promise<Cart> {
		const opaque = this.getCartid();
		const action = new CartAction(undefined, c, q);
		if (p) {
			action.productid = p.id;
		}
		return this.mapResponse(this.http.post(`/ws/ecommerce/cart/${opaque}/add`, classToPlain(action)), Cart);
	}

	remove(c: CartItem): Promise<Cart> {
		const opaque = this.getCartid();
		const action = new CartAction(c);
		return this.mapResponse(this.http.post(`/ws/ecommerce/cart/${opaque}/delete`, classToPlain(action)), Cart);
	}

	selectAddress(address: Address): Promise<Cart> {
		const opaque = this.getCartid();
		if (address.note) {
			// this._cart.value.shipnote = shipnote;
		}
		const action = new CartAction(undefined, undefined, undefined, undefined, address.id);
		return this.mapResponse(this.http.post(`/ws/ecommerce/cart/${opaque}/selectaddress`, classToPlain(action)), Cart);
	}

	updateQuantity(c: CartItem, q: number): Promise<Cart> {
		const opaque = this.getCartid();
		const action = new CartAction(c, undefined, q);
		return this.mapResponse(this.http.post(`/ws/ecommerce/cart/${opaque}/edit`, classToPlain(action)), Cart);
	}

	reprice(coupon: string): Promise<Cart> {
		const opaque = this.getCartid();
		const action = new CartAction(undefined, undefined, undefined, undefined, undefined, coupon);
		return this.mapResponse(this.http.post(`/ws/ecommerce/cart/${opaque}/reprice`, classToPlain(action)), Cart);
	}

	merge(opaque: string): Promise<Cart> {
		return this.mapResponse(this.http.post(`/ws/ecommerce/cart/${opaque}/merge`, {}), Cart);
	}

	replace(opaque: string): Promise<Cart> {
		return this.mapResponse(this.http.post(`/ws/ecommerce/cart/${opaque}/replace`, {}), Cart);
	}

}
